import React from 'react'

import dynamic from 'next/dynamic'
import Experiment from '@mc/experiments-react'

import type { CMTrailerHeroProps } from './CMTrailerHero'

const CMTrailerHero = dynamic(
  () => import('./CMTrailerHero').then((m) => m.CMTrailerHero),
  { ssr: true },
)

// https://app.growthbook.io/features/pen-4874_v1
export const CM_HERO_IS_A_TRAILER_FLAG = 'pen-4874_v1'

type ExpProps = {
  Control: React.ComponentType
} & CMTrailerHeroProps

const CMHeroIsATrailerExperimentInner = ({
  Control,
  content,
  growthClass,
}: ExpProps) => (
  <Experiment
    name={CM_HERO_IS_A_TRAILER_FLAG}
    control={() => <Control />}
    variant_1={() => (
      <CMTrailerHero content={content} growthClass={growthClass} />
    )}
  />
)

export const CMHeroIsATrailerExperiment = React.memo(
  CMHeroIsATrailerExperimentInner,
)
